import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductVariant } from '../data/models';

@Component({
    selector: 'app-product-details-variant-list[variants]',
    styles: [`
  `],
    template: `
    <div *ngFor="let variant of variants"
         (click)="variantSelected.emit(variant)"
         [class.list-group-item-info]="variant?.id === selectedVariant?.id"
         class="cursor-pointer list-group-item list-group-item-action border-bottom border-top-0 border-start-0 border-end-0 d-flex flex-row">
      <div class="d-block square-image-m h-56px h-sm-80px bg-light shadow-sm border justify-content-center"
           [style.background-image]="variant.images.length > 0 && variant.images[0].url && 'url(' + variant.images[0].url + ')'"></div>
      <div class="ps-3 d-flex flex-column flex-grow-1 justify-content-center">
        <span class="fw-bold">{{variant.option01}}</span>
        <span class="text-muted">{{variant.code}}</span>
        <span class="text-info fw-bold">{{variant.price | currency}}</span>
      </div>
      <div class="d-flex align-items-center">
        <span *ngIf="variant.stock && variant.stock > 0" class="text-success" i18n>{{variant?.stock}} stück</span>
        <span *ngIf="variant.stock === 0" class="text-danger" i18n>Ausverkauft</span>
        <span *ngIf="variant.stock === null" class="text-success" i18n>∞ stück</span>
      </div>
    </div>
  `,
    standalone: false
})
export class ProductDetailsVariantListComponent {
  @Input() variants: ProductVariant[] = [];
  @Input() selectedVariant!: ProductVariant | null;
  @Output() variantSelected: EventEmitter<ProductVariant> = new EventEmitter<ProductVariant>();
}
